import React, { useEffect, useState, useCallback } from "react";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import { useSelector } from "react-redux";
import config from "../../../../config";
import axios from "axios";
import calculateAge from "../../../Common/commonfunctions";
import { useGetUsersByLookingForQuery } from "./slice/matchSlice";
import { toast } from "../../../Common/Toast";
import { useConnection } from "./ConnectionContext";
import { useNavigate } from "react-router-dom";
import { Link } from "react-router-dom";

// Custom Arrow Components (same as before)
function SampleNextArrow(props) {
  const { className, onClick } = props;
  return (
    <div
      className={className}
      onClick={onClick}
      style={{
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        background: "#0977af",
        borderRadius: "50%",
        width: "35px",
        height: "35px",
        right: "-15px",
        zIndex: 2,
      }}
    />
  );
}

function SamplePrevArrow(props) {
  const { className, onClick } = props;
  return (
    <div
      className={className}
      onClick={onClick}
      style={{
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        background: "#0977af",
        borderRadius: "50%",
        width: "35px",
        height: "35px",
        left: "-15px",
        zIndex: 2,
      }}
    />
  );
}

const settings = {
  dots: false,
  infinite: true,
  speed: 500,
  slidesToShow: 4,
  slidesToScroll: 1,
  arrows: true,
  nextArrow: <SampleNextArrow />,
  prevArrow: <SamplePrevArrow />,
  responsive: [
    {
      breakpoint: 1024,
      settings: { slidesToShow: 3 },
    },
    {
      breakpoint: 768,
      settings: { slidesToShow: 2 },
    },
    {
      breakpoint: 480,
      settings: { slidesToShow: 1 },
    },
  ],
};

const RecentVisitors = () => {
  const [visitors, setVisitors] = useState([]);  
  const user = useSelector((state) => state.user.userInfo)
  const token = useSelector((state) => state.user.token)
  const { connections, updateConnection } = useConnection();
  const navigate = useNavigate()
  
  const lookingFor = user?.looking_for;
  const searchFor = lookingFor === "Bride" ? "Groom" : "Bride";
  
  // Add refetch function from RTK Query
  const { data, isLoading, isError, refetch } = useGetUsersByLookingForQuery({
    id: user.id,
    looking_for: searchFor
  });
  // console.log("Profiles: ", data?.users)

  // Merge server data with local connection state
  useEffect(() => {
    if (data?.success && Array.isArray(data.users)) {
      const mergedVisitors = data.users.map(visitor => ({
        ...visitor,
      }));
      setVisitors(mergedVisitors);
    }
  }, [data, connections]); // Add connections to dependency array

  // Handle connect with server sync
  const handleConnect = async (userId, profileId) => {
    // Prevent duplicate requests
    const isAlreadyConnected = connections[userId] === 1;
    const visitor = visitors.find(v => v.user_id === userId);
    if (isAlreadyConnected || visitor?.connectionRequest === 1) {
      toast.info("Already connected");
      return;
    }

    // Update UI immediately
    setVisitors(prev => prev.map(visitor => 
      visitor.user_id === userId 
        ? { ...visitor, connectionRequest: 1 } 
        : visitor
    ));
    
    updateConnection(userId, 1);

    try {
      // Send the connection notification
      await axios.post(`${config.baseURL}/api/notifications/send`, {
        receiver_user_id: userId,
        receiver_profile_id: profileId,
        sender_user_id: user?.user_id,
        sender_profile_id: user?.profileId,
        type: "connect",
        message: `${user?.first_name} wants to connect with you`,
      }, {
        headers: {
          Authorization: `Bearer ${token}`
        }
      });

      // Refetch data to ensure sync with server
      await refetch();
      
      toast.success("Connection request sent successfully");

    } catch (error) {
      // Revert UI on error
      setVisitors(prev => prev.map(visitor => 
        visitor.user_id === userId 
          ? { ...visitor, connectionRequest: 0 } 
          : visitor
      ));
      updateConnection(userId, 0);
      
      console.error("Error sending connection request:", error);
      
      if (error.response?.data?.message) {
        toast.error(error.response.data.message);
      } else {
        toast.error("Failed to send connection request");
      }
    }
  };

  // Check connection status
  const isConnected = (userId) => {
    // console.log("connections", connections)
    return connections[userId] === 1 || 
           visitors.find(v => v.user_id === userId)?.connectionRequest === 1;
  };

  if (isLoading) return <p>Loading...</p>;
  if (isError) return <p>Error loading visitors</p>;

  return (
    <div className="recent-visitor mt-5 px-3 position-relative">
      <h6 className="mb-3">
        Recent Visitors{" "}
        <span className="badge bg-danger ms-2">{visitors.length}</span>
      </h6>

      <Slider {...settings}>
        {visitors.map((visitor, index) => (
          <div key={`${visitor.user_id}-${index}`}>
            
              <div className="profile-blk text-center px-2">
                <div className="img-profile mb-2">
                  <img
                    src={visitor.profile_image ? `${config.baseURL}/uploads/profiles/${visitor.profile_image}` : "/images/no-image-found.webp"}
                    alt={`${visitor.first_name} ${visitor.last_name}`}
                    className="rounded-circle"
                    style={{
                      width: "150px",
                      height: "150px",
                      objectFit: "cover",
                      margin: "0 auto",
                    }}
                  />
                </div>
                <Link 
                to={`/profile/${visitor?.profileId}`} 
                style={{ textDecoration: "none", color: "black" }}
                state={{
                  profile: visitor,
                  currentUser: user,
                  source: "regular-matches"
                }}
              ><h6>{visitor.first_name} {visitor.last_name}</h6></Link>
                <p className="text-muted" style={{ fontSize: "14px" }}>
                  {calculateAge(visitor.birth_day, visitor.birth_month, visitor.birth_year)} years, {visitor.height}, {visitor.language},{" "}
                  {visitor.city}
                </p>
                
                {isConnected(visitor.user_id) ? 
                (<p style={{
                    color: "#0977af",
                    padding: "6px 16px",
                    fontWeight: "bold",
                  }}>Request Sent</p>)  
                 : (
                  <div className="connect-btn mt-2">
                    <button
                      className="btn btn-sm"
                      style={{
                        backgroundColor: "#0977af",
                        color: "#fff",
                        borderRadius: "20px",
                        padding: "6px 16px",
                        fontWeight: "bold",
                        border: "none",
                        cursor: "pointer",
                      }}
                      onClick={() => handleConnect(visitor.user_id, visitor.profileId)}
                    >
                      Add Now
                    </button>
                  </div>
                )}
              </div>
          </div>
        ))}
      </Slider>
    </div>
  );
};

export default RecentVisitors;